import React, { useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  navigateFromPracticeOrigin,
  goBackFromPracticePage,
} from "../../../../../custom_utilities/dashboardBannerNavigation";
import { ClipLoader } from "react-spinners";
import {
  fetchSubjectListRequest,
  getPyqSubjectWiseRequest,
  setActiveSubject,
  setSelectedTopic,
} from "../../../../../redux/exam/examSlice";
import { resolveMediaUrl } from "../../../../../custom_utilities/pyqFormatUtils";
import "./PyqTopicWise.css";
import images from "../../../../../utilities/images/images";

const PyqTopicWise = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { loadingTopics } = useSelector((state) => state.examSlice);
  const {
    subjectList,
    pyqSubjectWiseTopics,
    activeSubject,
    plannerDetails,
  } = useSelector((state) => state.examSlice);

  const paper_type = plannerDetails?.id;
  const category_id = plannerDetails?.category_id || paper_type;
  const isExamCrackerFlow =
    Number(paper_type) === 6 ||
    Number(paper_type) === 8 ||
    Number(paper_type) === 9;

  const visibleSubjects = useMemo(
    () =>
      subjectList?.filter((sub) => sub.sub_name !== "Information") || [],
    [subjectList]
  );

  const fetchTopicsForSubject = useCallback(
    (subjectName) => {
      if (!subjectName || !paper_type) return;
      dispatch(
        getPyqSubjectWiseRequest({
          subject: subjectName,
          paper_type,
          category_id,
        })
      );
    },
    [dispatch, paper_type, category_id]
  );

  useEffect(() => {
    if (paper_type) {
      dispatch(fetchSubjectListRequest({ category_id }));
    }
  }, [dispatch, category_id, paper_type]);

  useEffect(() => {
    if (!visibleSubjects.length) return;

    const isCurrentSubjectValid = visibleSubjects.some(
      (sub) => sub.sub_name === activeSubject
    );

    if (!isCurrentSubjectValid) {
      dispatch(setActiveSubject(visibleSubjects[0].sub_name));
      return;
    }

    fetchTopicsForSubject(activeSubject);
  }, [visibleSubjects, activeSubject, dispatch, fetchTopicsForSubject]);

  const handleSubjectChange = (subjectName) => {
    dispatch(setActiveSubject(subjectName));
    fetchTopicsForSubject(subjectName);
  };

  const handleTopicSelect = (topicId) => {
    const selectedTopic = pyqSubjectWiseTopics.find(
      (topic) => topic.topic_id === topicId
    );
    dispatch(setSelectedTopic(selectedTopic));
    navigateFromPracticeOrigin(history, "/practice/topic-wise/pyqset");
  };

  return (
    <div className="topic-wise-container">
      <div className="topic-wise-header">
        <img
          style={{
            marginLeft: "25px",
            width: "24px",
            height: "24px",
            cursor: "pointer",
          }}
          src={images.new_backarrow}
          alt="Back"
          onClick={() => goBackFromPracticePage(history, location)}
        />
        <h3 id="practice-wise">
          {isExamCrackerFlow ? "Exam Cracker" : "Topic Wise Practice"}
        </h3>
      </div>

      <div className="subject-tabs">
        {visibleSubjects.map((sub) => (
          <div
            key={sub.sub_id}
            className={`subject-tab ${
              activeSubject === sub.sub_name ? "active" : ""
            }`}
            onClick={() => handleSubjectChange(sub.sub_name)}
            style={{
              color: activeSubject === sub.sub_name ? sub.text_color : "#888",
            }}
          >
            <img
              src={resolveMediaUrl(sub.icon)}
              alt={sub.sub_name}
              referrerPolicy="no-referrer"
            />
            <span>{sub.sub_name}</span>
            <span
              className={`progress-badge ${
                activeSubject === sub.sub_name ? "active-badge" : ""
              }`}
            >
              {sub.progress_percent || 0}%
            </span>
          </div>
        ))}
      </div>
      {loadingTopics ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <ClipLoader size={40} color="#C61C26" />
        </div>
      ) : (
        <div className="topic-grid">
          {pyqSubjectWiseTopics?.map((topic) => (
            <div
              className="topic-card"
              key={topic.topic_id}
              onClick={() => handleTopicSelect(topic.topic_id)}
              style={{ cursor: "pointer" }}
            >
              <div className="topic-left">
                <img
                  src={resolveMediaUrl(topic.icon)}
                  alt={topic.topic_name}
                  referrerPolicy="no-referrer"
                />
                <div>
                  <h4>{topic.topic_name}</h4>
                </div>
              </div>

              <div className="topic-progress">
                <svg viewBox="0 0 36 36" aria-hidden="true">
                  <path
                    className="circle-bg"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path
                    className="circle"
                    strokeDasharray={`${topic.progress_percent || 0}, 100`}
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                </svg>
                <span className="percentage">{`${topic.progress_percent || 0}%`}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PyqTopicWise;
